import { Menu } from "lucide-react";
import { useAuthentication } from "src/context";
import { useSidebar } from "src/shadcn/ui/sidebar";
import { Button } from "src/shadcn/ui/button";

export function TopNavbar({ routeName }: { routeName?: string }) {
  const { userEmail } = useAuthentication();
  const { toggleSidebar, isMobile } = useSidebar();
  // const isCollapsed = state === "collapsed";

  return (
    <>
      {isMobile && (
        <header className="sticky top-0 flex items-center justify-between px-4 py-2 border-b border-gray-800 bg-black">
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleSidebar}
            className="text-gray-400 hover:text-white hover:bg-gray-800"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <div className="text-sm text-gray-300 font-medium flex items-center h-full">{userEmail}</div>
        </header>
      )}
      {/* <header className={`sticky bg-black text-white shadow-md flex items-center ${isCollapsed ? "h-10" : "h-18"}`}>
        <div
          className={`max-w-6xl mx-auto flex items-center w-full px-6 ${isCollapsed ? "justify-center" : "justify-between"}`}
        >
          <h1
            className={`${isCollapsed ? "text-base" : "text-2xl"} font-bold tracking-tight flex items-center justify-center`}
            style={{ height: "100%" }}
          >
            {routeName}
          </h1>
        </div>
      </header> */}
    </>
  );
}
